import React, { useState } from 'react'
import { Alert, Box, Stack, Typography, useTheme } from '@mui/material'
import PhoneInput from 'react-phone-input-2'
import { PhoneVerificationFormProps, PhoneVerificationFormState } from './types'

import {
  phoneVerification,
  stripCharactersFromPhone
} from '../../services/formhelper.service'
import { TransitionButton } from '../Buttons/TransitionButton'
import { PhoneDisclaimerContainer } from './PhoneDisclaimer.container'

import 'react-phone-input-2/lib/style.css'

export const PhoneVerificationFormComponent: React.FC<
  PhoneVerificationFormProps
> = ({ onSumbit, isLoading, isError }) => {
  const theme = useTheme()
  const [values, setValues] = useState<PhoneVerificationFormState>({
    primaryPhone: '',
    validationErrors: {}
  })

  const validate =
    (prop: keyof PhoneVerificationFormState) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      let validationErrors = {}
      if (prop === 'primaryPhone' && !phoneVerification(event.target.value)) {
        validationErrors = { phone: 'error' }
      }
      return validationErrors
    }

  const handleChange =
    (prop: keyof PhoneVerificationFormState) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setValues({
        ...values,
        [prop]: event.target.value,
        validationErrors: validate(prop)(event)
      })
    }

  const isDisabled = () =>
    !values.primaryPhone || Object.keys(values.validationErrors).length > 0

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    onSumbit({ primaryPhone: stripCharactersFromPhone(values.primaryPhone) })
  }

  return (
    <Stack
      component="form"
      spacing={3}
      noValidate
      onSubmit={handleSubmit}
      sx={{
        marginTop: theme.spacing(2),
        p: theme.breakpoints.only('xs') ? 0 : 2
      }}
    >
      <Typography
        component="h1"
        variant="h5"
        align="center"
        color="text.primary"
        gutterBottom
      >
        What’s your mobile number?
      </Typography>

      <div style={{ display: 'flex', margin: 'auto' }}>
        <PhoneInput
          country={'us'}
          onlyCountries={['us']}
          countryCodeEditable={false}
          value={values.primaryPhone || ''}
          onChange={(value, data, event) => handleChange('primaryPhone')(event)}
          placeholder="Mobile Number"
          inputProps={{
            name: 'primaryPhone',
            required: true
          }}
          inputStyle={{ minWidth: 250, height: 45, maxWidth: 300 }}
          disableDropdown
        />
      </div>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center'
        }}
      >
        <TransitionButton
          text="Next"
          type="submit"
          variant="contained"
          style={{ width: '8rem' }}
          loading={isLoading}
          disabled={isDisabled() || isLoading}
        />
      </Box>

      <PhoneDisclaimerContainer />

      {isError && (
        <Box sx={{ marginTop: 2 }}>
          <Alert severity="error">An error occurred.</Alert>
        </Box>
      )}
    </Stack>
  )
}
